import { create } from 'zustand';

export type UserRole =
  | 'SUPER_ADMIN'
  | 'SALON_OWNER'
  | 'MANAGER'
  | 'STAFF'
  | 'ACCOUNTANT'
  | 'ANALYST'
  | 'MARKETER'
  | 'IT'
  | 'CLIENT';

interface User {
  id: string;
  email: string;
  role: UserRole;
  firstName?: string;
  lastName?: string;
}

interface AuthState {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
  login: (token: string, user: User) => void;
  logout: () => void;
  setUser: (user: User) => void;
}

const storedUser = localStorage.getItem('visitio_user');

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem('visitio_token'),
  user: storedUser ? JSON.parse(storedUser) : null,
  isAuthenticated: !!localStorage.getItem('visitio_token'),
  login: (token, user) => {
    localStorage.setItem('visitio_token', token);
    localStorage.setItem('visitio_user', JSON.stringify(user));
    set({ token, user, isAuthenticated: true });
  },
  logout: () => {
    localStorage.removeItem('visitio_token');
    localStorage.removeItem('visitio_user');
    localStorage.removeItem('visitio_active_salon_id');
    set({ token: null, user: null, isAuthenticated: false });
  },
  setUser: (user) => {
    localStorage.setItem('visitio_user', JSON.stringify(user));
    set({ user });
  },
}));
